module.exports = __webpack_public_path__ + "img/weixins.1c5b2155.png";